import { Model, Property } from '@shared/model-system';

/** Division model using the model system */
export class Division extends Model {
  @Property() public id: string;
  @Property() public name: string;
  @Property() public homeDivision: boolean;
}
